import React from 'react'
import styled from '@emotion/styled'
import { fontSizeMedium, fontSize2XSmall, fontWeightBold } from '../../constants/principles'

export default () => (
  <MainDiv>
    <Header data-testid={`oc-txt-what-make-ineligible`} >What makes a vehicle ineligible?</Header>
    <Subheader>It could be a lot of things.</Subheader>
    <ul>
      <li>
        <ListItem>Some vehicles are rare, so there aren't enough vehicles for a good sales history.</ListItem>
      </li>
      <li>
        <ListItem>Certain equipment (especially vehicle modifications) can make a vehicle ineligible.</ListItem>
      </li>
      <li>
        <ListItem>Or maybe the vehicle has title issues, poor condition, or mileage over 300,000.</ListItem>
      </li>
    </ul>
  </MainDiv>
)

const MainDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px 0;
`
const Header = styled.div`
  font-size: ${fontSizeMedium};
  font-weight: ${fontWeightBold};
`
const Subheader = styled.div`
  font-size: ${fontSize2XSmall};
  padding-bottom: 32px;
`
const ListItem = styled.div`
  font-size: ${fontSize2XSmall};
  font-weight: ${fontWeightBold};
  padding-bottom: 8px;
`
